import './Recommend.css'
import { Card } from "antd";
import { FC } from "react";
import { RecommendBubble } from "../../types";
import { useResponxiveContext } from '../../context/responsive-context';
const { Meta } = Card

export const RecommendCard: FC<RecommendBubble> = (recommendBubble) => {
  const { isMobile, useVertical } = useResponxiveContext()
  return (
    <Card
      className={isMobile ? "Recommend-card-mobile" : useVertical ? "Recommend-card-vertical" : "Recommend-card"}
      size={ isMobile ? "small" : "default" }
    >
    <Meta
      description={
        <div style={ { color: 'black' } }>
          {recommendBubble.text}
        </div>
      }
    />
    </Card>
  )
}
